<template>
  <div class="main">
    <div class="content">
      <div class="top">
        <div class="logo" @click="changeTab('register')">
          <div class="icon">
            <img :src="require('../../../../public/static/images/logo.png')" alt="" />
          </div>
          <div class="name">智慧报考</div>
        </div>
        <div class="user" style="display: flex;">
          <el-badge :hidden="unReads === 0" :value="unReads" class="item">
            <a @click="gomessage()" style="color: #fff;">
              消息
            </a>
          </el-badge>
          <el-dropdown ref="dropdownRef" trigger="hover" @command="handleCommand" style="margin-left: 20px;">
            <span class="el-dropdown-link">
              <a class="el-dropdown-link-text">{{ user && user.sub }}</a><i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-plus" command="center"> 个人中心 </el-dropdown-item>
              <el-dropdown-item icon="el-icon-circle-plus" command="logout"> 退出 </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="tabbar">
        <div class="left">
          <template v-for="item in tabbarList">
            <div class="tabbar-item" :class="activeTabbar === item.type ? 'active-tabbar-item' : ''"
              @click="changeTab(item.type)">
              {{ item.name }}
            </div>
          </template>

          <!-- <div class="tabbar-item" @click="changeTab('register')">
            在线报名
          </div>
          <div class="tabbar-item" @click="changeTab('registrationQuery')">
            报名查询
          </div>
          <div class="tabbar-item" @click="changeTab('resultsInquiry')">
            成绩查询
          </div> -->
        </div>
        <!-- <div class="right">
          <div class="tabbar-item" @click="toConsult">
            咨询与备考
          </div>
        </div> -->
      </div>
    </div>
    <!-- 通知列表-->
    <el-dialog class="tzlb" width="80%" top="6vh" title="通知列表" :visible.sync="dialogVisible"
      :before-close="handleClose">
      <ul class="dataList">
        <!-- isRead -->
        <li class="mes-item" v-for="(item, index) in tableData" :key="item.id" @click="handleChange(index, item)">
          <div style="display: flex;">
            <span v-if="item.isRead === 1" class="green">[已读]</span>
            <span v-else class="red">[未读]</span>
            <span class="contnet_text">标题：{{ item.title }}</span>
            <span class="contnet_text">考点名称：{{ item.examTitle }}</span>
          </div>
          <div>
            <span>{{ item.createTime | parseTime }}</span>
          </div>

        </li>
      </ul>

      <el-pagination class="pagination" background layout="total, sizes, prev, pager, next" :total="this.total"
        :page-sizes="[10, 20, 50]" :page-size="this.listQuery.pageSize" :current-page="this.listQuery.pageNum"
        @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </el-dialog>

    <el-dialog title="通知内容" :visible.sync="dialogVisible2" width="60%" :before-close="handleClose2">
      <div class="title">{{ title }}</div>
      <div class="content2" v-html="content" style="text-align: left;"></div>
    </el-dialog>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import BASE64 from '@/utils/base'
import { noReadCount, getUserList, schoolNoticeuser } from '@/api/common'
import { parseTime } from '@/utils/time'
export default {
  data() {
    return {
      dialogVisible2: false,
      title: '',
      content: '',
      total: 0,
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      dialogVisible: false,
      unReads: 0,
      activeTabbar: 'register',
      tabbarList: [
        // { name: '首页', type: 'main' },
        { name: '在线报名', type: 'register' },
        { name: '报名查询', type: 'registrationQuery' },
        { name: '打印准考证', type: 'print' },
        { name: '成绩查询', type: 'resultsInquiry' }
      ],
      user: null
    }
  },
  mounted() {
    this.parseToken()
    this.noReadCount()

  },
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}:{s}') || '--'
    }
  },
  watch: {
    '$route.query.type': {
      immediate: true,
      handler(newValue) {
        if (!newValue) return
        this.activeTabbar = newValue
      }
    }
  },

  methods: {
    noReadCount() {
      noReadCount().then(res => {
        console.log(res);
        this.unReads = res || 0
      })
    },
    async handleChange(idx, item) {
      this.title = item.title
      this.content = item.content
      this.dialogVisible2 = true
      if (item.isRead === 1) return
      let params = { "noticeid": item.id, "userid": item.userId }
      await schoolNoticeuser(params).then(async res => {
        console.log(res);

        await this.gomessage()
        await this.noReadCount()
      })

    },
    handleClose2() {
      this.dialogVisible2 = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    gomessage() {
      getUserList(this.listQuery).then(res => {
        console.log(res.list);
        this.tableData = res.list
        this.total = res.total
        this.dialogVisible = true
      })
    },
    changeTab(type) {
      this.activeTabbar = type
      if (type === 'main') {
        this.$router.push({ path: '/', query: { type: 'main' } })
      }
      if (type === 'register') {
        this.$router.push({ path: '/register', query: { type: 'register' } })
      }
      if (type === 'registrationQuery') {
        this.$router.push({ path: '/registrationQuery', query: { type: 'registrationQuery' } })
      }
      if (type === 'resultsInquiry') {
        this.$router.push({ path: '/resultsInquiry', query: { type: 'resultsInquiry' } })
      }
      if (type === 'print') {
        this.$router.push({ path: '/print', query: { type: 'print' } })
      }
    },
    toConsult() {
      this.activeTabbar = 'consult'
      this.$router.push({ path: '/consult', query: { type: 'consult' } })
    },
    /* 退出 */
    handleCommand(commond) {
      if (commond === 'logout') {
        this.$store.dispatch('logout').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      }
      if (commond === 'center') {
        this.$router.push({ path: '/personalCenter' })
      }
      this.$nextTick(() => {
        this.$refs['dropdownRef'].hide()
      })
    },
    /* 解析token */
    parseToken() {
      const token = getToken().split('.')
      // console.log(token)
      let x = token[1].replace(/-/g, '+').replace(/_/g, '/')
      let out, i, len, c
      out = ''
      len = x.length
      for (i = 0; i < len; i++) {
        c = x.charCodeAt(i)
        if (c >= 0x0001 && c <= 0x007f) {
          out += x.charAt(i)
        } else if (c > 0x07ff) {
          out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f))
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
        } else {
          out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
        }
      }
      const userInfo = window.atob(out)
      localStorage.setItem('userInfo', userInfo)
      this.user = JSON.parse(userInfo)
      // console.log(this.user)
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.gomessage()
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val
      this.gomessage()
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/MainMenu.mobile';
}

@media screen and (min-width: 769px) {
  @import '../styles/MainMenu.pc';
}

ul li {
  list-style: none;
  padding: 10px;
  cursor: pointer;
}

.notice-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mes-item {
  display: flex;
  justify-content: space-between;

  div {
    &>span {
      line-height: 48px;
      font-size: 16px;
      margin-right: 10px;

      &.red {
        color: #C00;
      }

      &.green {
        color: #0C0;
      }
    }
  }


  .el-collapse-item {
    flex: 1;
  }
}

.tzlb {
  ::v-deep .el-dialog {}

  ::v-deep .el-dialog__body {
    height: 70vh;

    .dataList {
      height: calc(100% - 60px);
      overflow-y: scroll;
    }
  }
}

.pagination {
  position: absolute;
  bottom: 25px;
  left: 0;
  right: 0;
}

.time {
  position: absolute;
  right: 70px;
}

.contnet_text {
  // display: inline-block;
  margin-left: 20px;
  /* 隐藏超出容器的文本 */
  overflow: hidden;

  /* 强制文本在一行内显示 */
  white-space: nowrap;

  /* 超出部分用省略号表示 */
  text-overflow: ellipsis;
  max-width: 300px !important;
}
</style>
